import React, { memo } from 'react';
import { clsx } from 'clsx';

export type SectionShellProps = {
  bgClass?: string;
  className?: string;
  withContainer?: boolean;
  id?: string;
  children: React.ReactNode;
};

function SectionShellBase({
  bgClass = 'bg-navy-top',
  className,
  withContainer = true,
  id,
  children,
}: SectionShellProps) {
  return (
    <section
      id={id}
      className={clsx(
        'relative py-10 sm:py-16 lg:py-28 section-merge',
        '[contain-intrinsic-size:800px]',
        '[contain:layout_paint_style]',
        bgClass,
        className
      )}
    >
      {withContainer ? (
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
      ) : (
        children
      )}
    </section>
  );
}

const SectionShell = memo(SectionShellBase, (prevProps, nextProps) => {
  return (
    prevProps.bgClass === nextProps.bgClass &&
    prevProps.className === nextProps.className &&
    prevProps.withContainer === nextProps.withContainer &&
    prevProps.id === nextProps.id &&
    prevProps.children === nextProps.children
  );
});

SectionShell.displayName = 'SectionShell';

export default SectionShell;